import { createStructuredSelector } from 'reselect';
import {
  activeProcessType,
  isLocked,
  loadingOverlayOptions,
  artboardScale,
  showPreview,
  showScreensPanel,
} from 'containers/App/selectors';
import { activeArtboard } from 'containers/Artboards/selectors';
import { projectFlatColors } from 'containers/BrandDefinition/selectors';
import { artboardBackgroundFromMasterScreen } from 'containers/Project/selectors';
import { rootDocument } from 'containers/RootDocument/selectors';

export const projectScreenSelector = createStructuredSelector({
  isLocked,
  activeProcessType,
  options: loadingOverlayOptions,
  activeArtboard,
  artboardBackgroundFromMasterScreen,
  colors: projectFlatColors,
  rootDocument,
  showScreensPanel,
  showPreview,
  scale: artboardScale,
});
